import React from 'react';
import { Query } from '@apollo/client/react/components';
import Styled from 'styled';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ScrollToTop from 'lib/scroll/scroll-to-top';

import { Site } from 'four-nets/site';
import { NotFoundError } from 'four-nets/router/errors';
import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import Create from 'four-nets/photoblog/create-post/create';
import ErrorPage from 'four-nets/errors/error-page';
import VendorPresentation from 'four-nets/vendor/vendor-presentation/vendor-presentation';
import ComposeMailDialog from 'four-nets/mails/compose-mail/compose-mail-dialog';
import UserBrands from 'four-nets/user-brand/user-brands/user-brands';
import { ShowForUnpaidVendor } from 'four-nets/vendor/permissions';
import VendorUserBrands from 'four-nets/user-brand/vendor-user-brands/vendor-user-brands';

import FeedFilter from './feed-filter/feed-filter';
import AuthorSideLoader from './author-side/author-side-loader';
import UserFeedLoader from './user-feed-loader';
import Cover from './cover/cover';

import WeddingAlbum from './wedding-album/wedding-album';
import fixThisMessPlease from './user-feed-loader.graphql';
import query, { UserBlogQuery, UserBlogQueryVariables } from './user-blog.graphql';
import { PostType } from './user-feed-loader.graphql.types';
import SiteInfo from './site-info/site-info';

import defaultStyles from './user-blog.scss';
import { FIRST } from '../feed/feed-loader';

export interface Params {
    type?: string;
    imageId: string;
    slug?: string;
    username: string;
}

interface Search {
    post_type?: PostType;
    offset: number;
    'tab-vendor-info-recoms': boolean;
}

export interface Props extends RouteComponentProps<Params> {
    styles: typeof defaultStyles;
    search: Search;
    isVendor: boolean;
}

interface State {
    commentId?: string;
    showMore: boolean;
    open: boolean;
    to: string[];
}

class UserBlog extends React.PureComponent<Props, State> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    state = { open: false, showMore: false, to: [] };

    onWriteMailClick = (to: string) => {
        this.setState({ to: [to], open: true });
    };

    onClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { site } = this.context;
        const { styles, location, match, search, isVendor } = this.props;
        const { open, to } = this.state;
        const { hash, pathname, state } = location;
        const scrollToUserBrands =
            (state && state.scrollToUserBrands) ||
            (search && search['tab-vendor-info-recoms'] !== undefined) ||
            hash.match(/#?tab-vendor-info-recoms/);

        const { params } = match;
        const { username, slug, imageId } = params;
        const { post_type: postType, offset } = this.props.search;

        const matches = hash.match(/#comment-(\d+)/);

        return (
            <React.Fragment>
                <ComposeMailDialog open={open} to={to} onClose={this.onClose} />
                <ViewerConsumer>
                    {({ viewer }) => (
                        <Query<UserBlogQuery, UserBlogQueryVariables>
                            query={query}
                            variables={{ username }}
                            fetchPolicy='cache-first'
                        >
                            {({ data, error, loading, fetchMore }) => {
                                if (!loading && data && (!data.users || data.users.edges.length === 0)) {
                                    error = new NotFoundError();
                                }
                                const [user, userBlog, vendor] =
                                    data && data.users && data.users.edges.length > 0
                                        ? [
                                              data.users.edges[0]!.node!,
                                              data.users.edges[0]!.node!.photoBlog,
                                              data.users.edges[0]!.node!.profile.vendor,
                                          ]
                                        : [null, null, null];

                                return (
                                    <ErrorPage error={error}>
                                        {userBlog ? (
                                            <>
                                                <div className={styles.columns}>
                                                    <AuthorSideLoader
                                                        username={username}
                                                        location={location}
                                                        writeMail={this.onWriteMailClick}
                                                        userBlog={userBlog}
                                                        vendor={vendor || undefined}
                                                    />
                                                    {matches ? null : <ScrollToTop slug={slug} />}
                                                    <div>
                                                        <Cover
                                                            style={{ container: styles.coverContainer }}
                                                            {...userBlog}
                                                            edit={(viewer && viewer.username) === username}
                                                            isVendor={isVendor}
                                                            writeMail={this.onWriteMailClick}
                                                            vendor={vendor as any}
                                                        />
                                                        <div className={styles.column}>
                                                            {site && site.isWedding ? (
                                                                <>
                                                                    {userBlog.weddingAlbum ? (
                                                                        <WeddingAlbum
                                                                            {...userBlog.weddingAlbum}
                                                                            fetchMore={
                                                                                userBlog.weddingAlbum &&
                                                                                userBlog.weddingAlbum.images &&
                                                                                userBlog.weddingAlbum.images.pageInfo
                                                                                    .hasNextPage
                                                                                    ? (_: boolean = true) => {
                                                                                          const endCursor =
                                                                                              userBlog?.weddingAlbum
                                                                                                  ?.images?.pageInfo
                                                                                                  .endCursor;

                                                                                          return fetchMore({
                                                                                              variables: {
                                                                                                  after: endCursor,
                                                                                                  first: undefined,
                                                                                              },
                                                                                              updateQuery: (
                                                                                                  previousQueryResult,
                                                                                                  {
                                                                                                      fetchMoreResult,
                                                                                                      variables,
                                                                                                  }
                                                                                              ) => {
                                                                                                  return {
                                                                                                      users: {
                                                                                                          ...previousQueryResult.users,
                                                                                                          edges: [
                                                                                                              {
                                                                                                                  ...previousQueryResult
                                                                                                                      .users
                                                                                                                      .edges[0],
                                                                                                                  node: {
                                                                                                                      ...previousQueryResult
                                                                                                                          .users
                                                                                                                          .edges[0]
                                                                                                                          .node,
                                                                                                                      photoBlog:
                                                                                                                          {
                                                                                                                              ...previousQueryResult
                                                                                                                                  .users
                                                                                                                                  .edges[0]
                                                                                                                                  .node
                                                                                                                                  .photoBlog,
                                                                                                                              weddingAlbum:
                                                                                                                                  {
                                                                                                                                      ...previousQueryResult
                                                                                                                                          .users
                                                                                                                                          .edges[0]
                                                                                                                                          .node
                                                                                                                                          .photoBlog
                                                                                                                                          .weddingAlbum,
                                                                                                                                      images: {
                                                                                                                                          ...previousQueryResult
                                                                                                                                              .users
                                                                                                                                              .edges[0]
                                                                                                                                              .node
                                                                                                                                              .photoBlog
                                                                                                                                              .weddingAlbum
                                                                                                                                              .images,
                                                                                                                                          edges: [
                                                                                                                                              ...previousQueryResult
                                                                                                                                                  .users
                                                                                                                                                  .edges[0]
                                                                                                                                                  .node
                                                                                                                                                  .photoBlog
                                                                                                                                                  .weddingAlbum
                                                                                                                                                  .images
                                                                                                                                                  .edges,
                                                                                                                                              ...fetchMoreResult
                                                                                                                                                  .users
                                                                                                                                                  .edges[0]
                                                                                                                                                  .node
                                                                                                                                                  .photoBlog
                                                                                                                                                  .weddingAlbum
                                                                                                                                                  .images
                                                                                                                                                  .edges,
                                                                                                                                          ],
                                                                                                                                          pageInfo:
                                                                                                                                              {
                                                                                                                                                  ...previousQueryResult
                                                                                                                                                      .users
                                                                                                                                                      .edges[0]
                                                                                                                                                      .node
                                                                                                                                                      .photoBlog
                                                                                                                                                      .weddingAlbum
                                                                                                                                                      .images
                                                                                                                                                      .pageInfo,

                                                                                                                                                  hasNextPage:
                                                                                                                                                      false,
                                                                                                                                              },
                                                                                                                                      },
                                                                                                                                  },
                                                                                                                          },
                                                                                                                  },
                                                                                                              },
                                                                                                          ],
                                                                                                      },
                                                                                                  };
                                                                                              },
                                                                                          });
                                                                                      }
                                                                                    : undefined
                                                                            }
                                                                        />
                                                                    ) : null}
                                                                    {!vendor && site && site.isWedding ? (
                                                                        <UserBrands username={username} />
                                                                    ) : null}
                                                                </>
                                                            ) : null}
                                                            {site &&
                                                            site.isLiving &&
                                                            !Boolean(vendor) &&
                                                            (userBlog.siteInfo ||
                                                                Boolean(viewer && viewer.username === username)) ? (
                                                                <SiteInfo
                                                                    siteInfo={userBlog.siteInfo || ''}
                                                                    update={Boolean(
                                                                        viewer && viewer.username === username
                                                                    )}
                                                                />
                                                            ) : null}
                                                            {vendor ? <VendorPresentation {...vendor} /> : null}
                                                            {isVendor && vendor && site && site.isWedding ? (
                                                                <VendorUserBrands
                                                                    vendor={vendor}
                                                                    scrollToUserBrands={scrollToUserBrands}
                                                                    username={vendor.user.username}
                                                                />
                                                            ) : null}
                                                            <ShowForUnpaidVendor>
                                                                <div className={styles.expired}>
                                                                    <span className={styles.expiredText}>
                                                                        <FormattedMessage id='POSTING_DISABLED' />
                                                                    </span>
                                                                    <Link
                                                                        to={`/pro/${
                                                                            viewer && viewer.username
                                                                        }/payments/`}
                                                                        className={styles.expiredLink}
                                                                    >
                                                                        <FormattedMessage id='BUY_SUBSCRIPTION' />
                                                                    </Link>
                                                                </div>
                                                            </ShowForUnpaidVendor>
                                                            {!slug && viewer && viewer.username === username ? (
                                                                <Create
                                                                    style={{ container: styles.containerCreate }}
                                                                    refetchQueries={[
                                                                        {
                                                                            query: fixThisMessPlease,
                                                                            variables: {
                                                                                first: FIRST,
                                                                                username,
                                                                                postType,
                                                                            },
                                                                        },
                                                                    ]}
                                                                />
                                                            ) : null}
                                                            <FeedFilter
                                                                user={user}
                                                                postType={postType}
                                                                albumsCount={userBlog.albumsCount}
                                                                articlesCount={userBlog.articlesCount}
                                                            />
                                                            <UserFeedLoader
                                                                vendor={vendor}
                                                                username={username}
                                                                postType={postType}
                                                                slug={slug}
                                                                imageId={imageId}
                                                                offset={offset}
                                                                pathname={pathname}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className={styles.coverPlaceholder} />
                                        )}
                                    </ErrorPage>
                                );
                            }}
                        </Query>
                    )}
                </ViewerConsumer>
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(UserBlog);
